module.exports = __webpack_public_path__ + "static/media/search.2925ee38.svg";